import React from 'react';
import { ReactComponent as RocketLaunch } from '../Assets/img/Profile/rocketlunch.svg';

const ComingSoonPage = () => {
  return (
     <div style={{ padding: '40px', backgroundColor:"#f4f7fe", minHeight:"90vh" }}>
    <div className="coming-soon-container d-flex flex-column align-items-center justify-content-center min-vh-80  bg-white" 
         style={{ padding: '30px' }}>
      
      {/* Rocket Animation Container */}
      <div className="rocket-wrapper text-center mb-5" 
           style={{ animation: 'float 3s ease-in-out infinite' }}>
        <RocketLaunch width={200} height={200} />
      </div>

      {/* Coming Soon Text */}
      <h1 className="coming-soon-title text-center mb-4" 
          style={{ 
            color: '#0044C6',
            fontSize: 'clamp(1rem, 4vw, 2.5rem)',
            fontWeight: '800',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginBottom: '1rem',
            textShadow: '2px 2px 4px rgba(0, 68, 198, 0.1)'
          }}>
        Coming Soon
      </h1>

      {/* Description */}
      <p className="coming-soon-description text-center mb-3" 
         style={{ 
           color: '#0044C6',
           fontSize: 'clamp(0.5rem, 3vw, 1rem)',
           fontWeight: '500',
           opacity: 0.9,
           maxWidth: '600px',
           margin: '0 auto'
         }}>
        Are you Ready to get something new from us.
      </p>

      {/* Sub Description */}
      <p className="coming-soon-subdescription text-center" 
         style={{ 
           color: '#0044C6',
           fontSize: 'clamp(0.4rem, 2vw, 0.8rem)',
           fontWeight: '400',
           opacity: 0.7,
           maxWidth: '500px',
           margin: '0 auto'
         }}>
        Stay tuned for something amazing.
      </p>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
          100% {
            transform: translateY(0px);
          }
        }

        .coming-soon-container {
          position: relative;
          overflow: hidden;
        }

        /* Optional: Add decorative dots */
        .coming-soon-container::before,
        .coming-soon-container::after {
          content: '';
          position: absolute;
          width: 300px;
          height: 300px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0, 68, 198, 0.05) 0%, transparent 70%);
          z-index: 0;
        }

        .coming-soon-container::before {
          top: -150px;
          left: -150px;
        }

        .coming-soon-container::after {
          bottom: -150px;
          right: -150px;
        }

        .rocket-wrapper,
        .coming-soon-title,
        .coming-soon-description,
        .coming-soon-subdescription {
          position: relative;
          z-index: 1;
        }
      `}</style>
    </div>
    </div>
  );
};

export default ComingSoonPage;